import { render } from "./GibergMJewellery.vue?vue&type=template&id=90c4450c&scoped=true"
import script from "./GibergMJewellery.vue?vue&type=script&lang=js"
export * from "./GibergMJewellery.vue?vue&type=script&lang=js"

import "./GibergMJewellery.vue?vue&type=style&index=0&id=90c4450c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c4450c"]])

export default __exports__